import { Link } from "@tanstack/react-router";
import { Mail, Phone, MapPin, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { adminEntryPath } from "@/lib/admin-login-api";

export function SiteFooter() {
  const { t } = useI18n();
  const adminTo = adminEntryPath();
  return (
    <footer className="border-t border-border/60 bg-muted/20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-10 sm:px-6 md:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <span className="icon-tile h-9 w-9">
              <Sparkles className="h-4 w-4" />
            </span>
            <span className="font-serif text-lg font-bold">{t("appName")}</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">{t("footer_tagline")}</p>
        </div>
        <div>
          <h4 className="mb-4 font-serif text-sm font-bold text-foreground">{t("footer_quick")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>
              <a href="#about" className="hover:text-foreground">
                {t("nav_about")}
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-foreground">
                {t("nav_features")}
              </a>
            </li>
            <li>
              <a href="#how" className="hover:text-foreground">
                {t("footer_schedule")}
              </a>
            </li>
            <li>
              <a href="#faq" className="hover:text-foreground">
                {t("nav_faq")}
              </a>
            </li>
            <li>
              <Link to={adminTo} className="hover:text-foreground">
                {t("admin")}
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-serif text-sm font-bold text-foreground">
            {t("footer_contact")}
          </h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-primary" />
              <span suppressHydrationWarning>contact@jaingauravyatra.org</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-primary" />
              <span>+91 98250 00000</span>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-primary" />
              <span>{t("footer_location")}</span>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-serif text-sm font-bold text-foreground">{t("footer_get")}</h4>
          <Link to="/login" className="btn-primary w-full">
            {t("hero_cta_primary")}
          </Link>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 text-center text-xs text-muted-foreground">
        {t("footer_copy")}
      </div>
    </footer>
  );
}
